import { render, staticRenderFns } from "./ModalSafeOpening.vue?vue&type=template&id=56fa5c00&scoped=true"
import script from "./ModalSafeOpening.vue?vue&type=script&lang=js"
export * from "./ModalSafeOpening.vue?vue&type=script&lang=js"
import style0 from "./ModalSafeOpening.vue?vue&type=style&index=0&id=56fa5c00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56fa5c00",
  null
  
)

export default component.exports